// Tokens insertables en Términos y Condiciones. El admin escribe {{token}} en el editor; el
// cliente los rellena (autocompletando desde su perfil donde aplique) y acepta. Al releer, el
// documento se muestra con los valores insertados.
//
// source:
//  - 'profile': se autocompleta desde el campo del usuario (editable por el cliente).
//  - 'today'  : se precarga con la fecha de hoy (editable).
//  - 'manual' : el cliente lo escribe (firma, etc.).
export const LEGAL_TOKEN_REGISTRY = {
  nombre: { labelEs: 'Nombres', labelEn: 'First name', source: 'profile', field: 'first_name' },
  apellido: { labelEs: 'Apellidos', labelEn: 'Last name', source: 'profile', field: 'last_name' },
  documento: { labelEs: 'Número de documento', labelEn: 'Document number', source: 'profile', field: 'identification_number' },
  email: { labelEs: 'Correo electrónico', labelEn: 'Email', source: 'profile', field: 'email' },
  telefono: { labelEs: 'Teléfono', labelEn: 'Phone', source: 'profile', field: 'phone' },
  fecha: { labelEs: 'Fecha', labelEn: 'Date', source: 'today' },
  firma: { labelEs: 'Firma', labelEn: 'Signature', source: 'manual' }
};

// Token con espacios opcionales: {{ nombre }} o {{nombre}}.
export const TOKEN_REGEX = /\{\{\s*([a-zA-Z_]+)\s*\}\}/g;

export const tokenLabel = (key, lang = 'es') => {
  const def = LEGAL_TOKEN_REGISTRY[key];
  if (!def) return key;
  return lang === 'en' ? def.labelEn : def.labelEs;
};

// Devuelve las claves de token (únicas, en orden de aparición) presentes en el body y soportadas.
export const extractTokens = (body) => {
  if (!body) return [];
  const found = [];
  const re = new RegExp(TOKEN_REGEX.source, 'g');
  let match = re.exec(body);
  while (match !== null) {
    const key = match[1].toLowerCase();
    if (LEGAL_TOKEN_REGISTRY[key] && !found.includes(key)) found.push(key);
    match = re.exec(body);
  }
  return found;
};

// Valores iniciales: autocompletados desde el perfil / fecha de hoy / vacío.
export const buildInitialValues = (tokens, user, lang = 'es') => {
  const values = {};
  tokens.forEach((key) => {
    const def = LEGAL_TOKEN_REGISTRY[key];
    if (!def) { values[key] = ''; return; }
    if (def.source === 'profile') values[key] = (user && user[def.field]) || '';
    else if (def.source === 'today') values[key] = new Date().toLocaleDateString(lang === 'en' ? 'en-US' : 'es-CO');
    else values[key] = '';
  });
  return values;
};

const escapeHtml = (str) =>
  String(str)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');

// Reemplaza los tokens del body por su valor (escapado). Si un valor está vacío, deja un
// subrayado para que se note el espacio a llenar. El resultado pasa por ContentRenderer (sanitiza).
export const fillBody = (body, values) => {
  if (!body) return body;
  return body.replace(new RegExp(TOKEN_REGEX.source, 'g'), (matchStr, rawKey) => {
    const key = rawKey.toLowerCase();
    if (!(key in (values || {}))) return matchStr;
    const value = values[key];
    if (value === undefined || value === null || value === '') return '________';
    return escapeHtml(value);
  });
};
